// src/components/products/ProductForm/TourDetailsSections/DefaultTypeSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";
import TimeInput from "../../../inputs/TimeInput";

const DefaultTypeSection = ({
    formData,
    setFormData,
    errors,
    isArabic,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Default Operating Hours - Start */}
            <Grid item xs={12} md={6}>
                <TimeInput
                    label={isArabic ? 'وقت بداية التشغيل' : 'Operating Hours Start Time'}
                    value={formData.operating_hours_start_time || ''}
                    onChange={(e) => setFormData({
                        ...formData,
                        operating_hours_start_time: e.target.value
                    })}
                    required
                    error={!!errors.operating_hours_start_time}
                    helperText={errors.operating_hours_start_time}
                />
            </Grid>

            {/* Default Operating Hours - End */}
            <Grid item xs={12} md={6}>
                <TimeInput
                    label={isArabic ? 'وقت نهاية التشغيل' : 'Operating Hours End Time'}
                    value={formData.operating_hours_end_time || ''}
                    onChange={(e) => setFormData({
                        ...formData,
                        operating_hours_end_time: e.target.value
                    })}
                    required
                    error={!!errors.operating_hours_end_time}
                    helperText={errors.operating_hours_end_time}
                />
            </Grid>

            {/* Default Itinerary - Arabic */}
            {showArabic && (
                <Grid item xs={12}>
                    <FormInput
                        label="خط سير الرحلة الافتراضي (عربي)"
                        type="editor"
                        textareaRows={200}
                        name="default_itinerary_ar"
                        value={formData.default_itinerary?.ar || ''}
                        onChange={(e) => handleMultiLangChange('default_itinerary', 'ar', e.target.value)}
                        rows={4}
                        error={!!errors.default_itinerary_ar}
                        helperText={errors.default_itinerary_ar}
                    />
                </Grid>
            )}

            {/* Default Itinerary - English */}
            {showEnglish && (
                <Grid item xs={12}>
                    <FormInput
                        label="Default Itinerary (English)"
                        type="editor"
                        textareaRows={200}
                        name="default_itinerary_en"
                        value={formData.default_itinerary?.en || ''}
                        onChange={(e) => handleMultiLangChange('default_itinerary', 'en', e.target.value)}
                        rows={4}
                        error={!!errors.default_itinerary_en}
                        helperText={errors.default_itinerary_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default DefaultTypeSection;
